import React, { Suspense, lazy, useContext, useMemo } from "react";

/// React router dom
import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";


// import { LoginCallback, useOktaAuth } from "@okta/okta-react";
import { RequiredAuth } from "../../../SecureRoute";

/// Css
import "../../index.css";
import "../../chart.css";
import "../../step.css";

/// Layout
import Nav from "../../layouts/nav";
import Footer from "../../layouts/Footer";
import ScrollToTop from "../../layouts/ScrollToTop";
import { ThemeContext } from "../../../context/ThemeContext";
import Setting from "../../layouts/Setting";
import Deflayout from "../../layouts/nav/Deflayout";
import { useMsal } from "@azure/msal-react";

/// Dashboard
const Home = lazy(() => import("../Dashboard/Home"));
const HeartBeatDashboard = lazy(() => import("../Dashboard/HeartBeatDashboard"));
const Index4 = lazy(() => import("../Dashboard/Index4"));
const Index3 = lazy(() => import("../Dashboard/Index3"));

// import Task from "../../components/Dashboard/Task";


const DataClassificationApprovals = lazy(() => import("../Dashboard/DataClassificationApprovals"));
const DbtDashboard = lazy(() => import("../Dashboard/DbtDashboard"));
const QlikDashboard = lazy(() => import("../Dashboard/QlikDashboard"));
const MetroMap = lazy(() => import("../Dashboard/MetroMap"));
const POMetroMap = lazy(() => import("../Dashboard/PO-MetroMap"));
const DataQualityDB = lazy(() => import("../Dashboard/DataQualityDB"));
const BuildProDB = lazy(() => import("../Dashboard/BuildProDB"));

/// App
const AppProfile = lazy(() => import("../AppsMenu/AppProfile/AppProfile"));



//Icons
const IconSvg = lazy(() => import("../Icons/IconSvg"));

/// Charts
const SparklineChart = lazy(() => import("../charts/Sparkline"));
const ChartJs = lazy(() => import("../charts/Chartjs"));

const RechartJs = lazy(() => import("../charts/rechart"));
const ApexChart = lazy(() => import("../charts/apexcharts"));


/// Bootstrap
const UiAlert = lazy(() => import("../bootstrap/Alert"));
const UiAccordion = lazy(() => import("../bootstrap/Accordion"));
const UiBadge = lazy(() => import("../bootstrap/Badge"));
const UiButton = lazy(() => import("../bootstrap/Button"));
const UiModal = lazy(() => import("../bootstrap/Modal"));
const UiButtonGroup = lazy(() => import("../bootstrap/ButtonGroup"));
const UiListGroup = lazy(() => import("../bootstrap/ListGroup"));
const MediaObject = lazy(() => import("../bootstrap/MediaObject"));
const UiCards = lazy(() => import("../bootstrap/Cards"));
const UiCarousel = lazy(() => import("../bootstrap/Carousel"));
const UiDropDown = lazy(() => import("../bootstrap/DropDown"));
const UiPopOver = lazy(() => import("../bootstrap/PopOver"));
const UiProgressBar = lazy(() => import("../bootstrap/ProgressBar"));
const UiTab = lazy(() => import("../bootstrap/Tab"));
const UiPagination = lazy(() => import("../bootstrap/Pagination"));
const UiGrid = lazy(() => import("../bootstrap/Grid"));
const UiTypography = lazy(() => import("../bootstrap/Typography"));


/// Plugins
const Select2 = lazy(() => import("../PluginsMenu/Select2/Select2"));
const MainSweetAlert = lazy(() => import("../PluginsMenu/SweetAlert/SweetAlert"));
const Toastr = lazy(() => import("../PluginsMenu/Toastr/Toastr"));
const Lightgallery = lazy(() => import("../PluginsMenu/Lightgallery/Lightgallery"));
// import JqvMap from "../../components/PluginsMenu/JqvMap/JqvMap";

//Redux
const Todo = lazy(() => import("../../pages/Todo"));

/// Widget
const WidgetCard = lazy(() => import("../Widget/WidgetCard"));
const WidgetChart = lazy(() => import("../Widget/WidgetChart"));
const WidgetList = lazy(() => import("../Widget/WidgetList"));


/// Table
const SortingTable = lazy(() => import("../table/SortingTable/SortingTable"));
const FilteringTable = lazy(() => import("../table/FilteringTable/FilteringTable"));
const BootstrapTable = lazy(() => import("../table/BootstrapTable"));
// import DataTable from "../../components/table/DataTable";

/// Form
const Element = lazy(() => import("../Forms/Element/Element"));
const Wizard = lazy(() => import("../Forms/Wizard/Wizard"));
const Pickers = lazy(() => import("../Forms/Pickers/Pickers"));
const CkEditor = lazy(() => import('../Forms/CkEditor/CkEditor'));
const FormValidation = lazy(() => import('../Forms/FormValidation/FormValidation'));


/// Pages
const LockScreen = lazy(() => import("../../pages/LockScreen"));
const EmptyPage = lazy(() => import("../Dashboard/EmptyPage"));
const Error400 = lazy(() => import("../../pages/Error400"));
const Error403 = lazy(() => import("../../pages/Error403"));
const Error404 = lazy(() => import("../../pages/Error404"));
const Error500 = lazy(() => import("../../pages/Error500"));
const Error503 = lazy(() => import("../../pages/Error503"));
const Login = lazy(() => import("../../pages/Login"));
const RTBFApprovals = lazy(() => import("../Dashboard/RtbfApprovals"));
const PrefectDashboard = lazy(() => import("../Dashboard/PrefectDashboard"));
const JDEDashboard = lazy(() => import("../Dashboard/JDEDashboard"));
// const LoginCallback = lazy(() => import("../../pages/LoginCallback"));
const AwsGlueDashboard = lazy(() => import("../Dashboard/AwsGlueDashboard"));
const ProjectsKpi = lazy(() => import("../Dashboard/ProjectsKpiDashboard"));
const AwsAirflowDashboard = lazy(() => import("../Dashboard/AwsAirflowDashboard"));
const PowerBiDashboard = lazy(() => import("../Dashboard/pbi"));
const E1DQMetrics = lazy(() => import("../Dashboard/E1-DQMetrics"));

const SnowflakeDashboard = lazy(() => import("../Dashboard/SnowflakeDashboard"));
const allroutes = [

    // DATA CLASSIFICATION
    // { url: "/classification_dashboard", component: <DataClassificationDashboard /> },
    { url: "classification_approvals", component: <DataClassificationApprovals /> },

    /// RTBF DEMO 
    // { url: "rtbf_dashboard", component: <RtbfDashboardDark /> },
    { url: "rtbf_approvals", component: <RTBFApprovals /> },

    /// Dashboard
    // { url: "", component: <DashboardDark/> },    
    // { url: "dashboard", component: <RtbfDashboardDark /> },
    // { url: "dashboard", component: <Home /> },
    { url: "HeartbeatDashboard", component: <HeartBeatDashboard /> },
    { url: "data_quality_db", component: <DataQualityDB /> },
    { url: "dbt_dashboard", component: <DbtDashboard /> },
    { url: "prefect_dashboard", component: <PrefectDashboard /> },
    { url: "jde_dashboard", component: <JDEDashboard /> },
    { url: "aws_glue_dashboard", component: <AwsGlueDashboard /> },
    {url: "qlik_dashboard", component: <QlikDashboard />},
    {url: "metro_map", component: <MetroMap />},
    {url: "po_metro_map", component: <POMetroMap />},
    {url: "projects_kpi", component: <ProjectsKpi />},
    {url: "aws_airflow_dashboard", component: <AwsAirflowDashboard />},
    {url: "snowflake_dashboard", component: <SnowflakeDashboard />},
    {url: "buildpro_db", component: <BuildProDB />},
    {url: "e1_dq_metrics", component: <E1DQMetrics />},
    // { url: "dashboard-dark", component: <DashboardDark /> },

    // LENNAR DASHBOARDS
    // { url: "", component: <RtbfDashboardDark /> },
    // { url: "/dq" , component: <DataQualityDashboard /> },



    // { url: "task", component: <Task/> },    
    /// App User Experience
    { url: "app-profile", component: <AppProfile /> },
    


    //Icons	  
    { url: "icon-svg", component: <IconSvg /> },

    // Charts for Analytics
    { url: "chart-sparkline", component: <SparklineChart /> },
    { url: "chart-chartjs", component: <ChartJs /> },
    { url: "chart-apexchart", component: <ApexChart /> },
    { url: "chart-rechart", component: <RechartJs /> },

    /// Bootstrap
    { url: "ui-accordion", component: <UiAccordion /> },
    { url: "ui-alert", component: <UiAlert /> },
    { url: "ui-badge", component: <UiBadge /> },
    { url: "ui-button", component: <UiButton /> },
    { url: "ui-modal", component: <UiModal /> },
    { url: "ui-button-group", component: <UiButtonGroup /> },
    { url: "ui-list-group", component: <UiListGroup /> },
    { url: "ui-media-object", component: <MediaObject /> },
    { url: "ui-card", component: <UiCards /> },
    { url: "ui-carousel", component: <UiCarousel /> },
    { url: "ui-dropdown", component: <UiDropDown /> },
    { url: "ui-popover", component: <UiPopOver /> },
    { url: "ui-progressbar", component: <UiProgressBar /> },
    { url: "ui-tab", component: <UiTab /> },
    { url: "ui-pagination", component: <UiPagination /> },
    { url: "ui-typography", component: <UiTypography /> },
    { url: "ui-grid", component: <UiGrid /> },

    /// Plugin

    { url: "uc-select2", component: <Select2 /> },
    { url: "uc-sweetalert", component: <MainSweetAlert /> },
    { url: "uc-toastr", component: <Toastr /> },
    { url: "uc-lightgallery", component: <Lightgallery /> },

    ///Redux
    { url: "todo", component: Todo },

    /// Widget
    { url: "widget-card", component: <WidgetCard /> },
    { url: "widget-chart", component: <WidgetChart /> },
    { url: "widget-list", component: <WidgetList /> },


    // Form Components
    { url: "form-element", component: <Element /> },
    { url: "form-wizard", component: <Wizard /> },
    { url: "form-ckeditor", component: <CkEditor /> },
    { url: "form-pickers", component: <Pickers /> },
    { url: "form-validation", component: <FormValidation /> },

    /// Table Components	
    // { url: "table-datatable-basic", component: <DataTable/> },    
    { url: 'table-filtering', component: <FilteringTable /> },
    { url: 'table-sorting', component: <SortingTable /> },
    { url: "table-bootstrap-basic", component: <BootstrapTable /> },



    { url: "empty", component: <EmptyPage /> },
];

function MainLayout() {
    const { sidebariconHover } = useContext(ThemeContext);
    const sideMenu = useSelector(state => state.sideMenu);
    return (
        <div id="main-wrapper" className={`show ${sidebariconHover ? "iconhover-toggle" : ""} ${sideMenu ? "menu-toggle" : ""}`}>
            <Deflayout />
            <div className="content-body" >
                <div className="container-fluid" style={{ minHeight: window.screen.height - 45 }}>
                    <Outlet />
                </div>
            </div>
            <Setting />
            <Footer />
        </div>
    )
};

function MainLayout2() {
    const { sidebariconHover } = useContext(ThemeContext);
    const sideMenu = useSelector(state => state.sideMenu);
    return (
        <div id="main-wrapper" className={`show ${sidebariconHover ? "iconhover-toggle" : ""} ${sideMenu ? "menu-toggle" : ""}`}>
            <Nav />
            <div className="content-body" >
                <div className="container-fluid" style={{ minHeight: window.screen.height - 45 }}>
                    <Outlet />
                </div>
            </div>
            <Setting />1
            <Footer />
        </div>
    )
};

function NotFound() {
    const url = allroutes.map((route) => route.url);
    console.log("not found url")
    console.log(url)
    let path = window.location.pathname
    path = path.split('/')
    path = path[path.length - 1]
    console.log("PATH OF UNKNOWN")
    console.log(path)
    if (url.indexOf(path) <= 0) {
        return <Error404 />
    }
}

const EntraRoutes = () => {
    const { accounts } = useMsal();
    const isAuthenticated = accounts.length > 0;

    return (
      <Suspense
        fallback={
          <div id="preloader">
            <div className="sk-three-bounce">
              <div className="sk-child sk-bounce1"></div>
              <div className="sk-child sk-bounce2"></div>
              <div className="sk-child sk-bounce3"></div>
            </div>
          </div>
        }
      >
        <Routes>
          <Route element={<RequiredAuth />}>
            <Route element={<MainLayout />}>
              <Route path='/' element={<MetroMap />} />
              <Route path='/heartbeat' exact element={<HeartBeatDashboard />} />
              <Route path="projects_kpi" element={<ProjectsKpi />} />
              <Route path='/classification_approvals' element={<DataClassificationApprovals />} />
              <Route path='/rtbf_approvals' element={<RTBFApprovals />} />
              <Route path='/dashboard' element={<Home />} />
              {/* <Route path='/dashboard' element={<HeartBeatDashboard />} /> */}
              <Route path='/HeartbeatDashboard' element={<HeartBeatDashboard />} />
              <Route path='/dbt_dashboard' element={<DbtDashboard />} />
              <Route path='/prefect_dashboard' element={<PrefectDashboard />} />
              <Route path='/jde_dashboard' element={<JDEDashboard />} />
              <Route path='/aws_glue_dashboard' element={<AwsGlueDashboard />} />
              <Route path='/dq' element={<DataQualityDB />} />
              <Route path='/empty' element={<EmptyPage />} />
              <Route path='/table-filtering' element={<FilteringTable />} />
              <Route path='/qlik_dashboard' element={<QlikDashboard />} />
              <Route path='/snowflake_dashboard' element={<SnowflakeDashboard />} />
              
              <Route path='/pbi' element={<PowerBiDashboard />} />
              <Route path='/aws_airflow_dashboard' element={<AwsAirflowDashboard />} />
              <Route path='/buildpro_db' element={<BuildProDB />} />
              <Route path='/e1_dq_metrics' element={<E1DQMetrics />} />
              <Route path='/po_metro_map' element={<POMetroMap />} />
              <Route path='/po-metro-map' element={<POMetroMap />} />
            </Route>
            <Route element={<MainLayout2 />}>
              <Route path="/index-3" element={<Index3 />} />
              <Route path="/index-4" element={<Index4 />} />
            </Route>
          </Route>
  
          {!isAuthenticated && (
            <>
              {/* <Route path='/login/callback' element={<Login />} /> */}
              <Route path='/login' element={<Login />} />
            </>
          )}
  
          {/* Handle unmatched routes, redirect to login or show not found */}
          <Route path='*' element={<NotFound />} />
        </Routes>
        <ScrollToTop />
      </Suspense>
    );
  }
  
  export default EntraRoutes;
